import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { constant } from '../../app.constants';
import {
  IDriverQualificationsResponse,
  IQualificationDriverPayRequest,
  IQualificationDriverRequest,
  IQualificationRequest,
  IQualificationResponse,
} from '../interfaces/qualification.interface';
import { IResponseSuccess } from '../interfaces/response.interface';
import { IProviderQualification } from '../interfaces/provider-qualification.interface';

@Injectable()
export class QualificationApiService extends ParentService {
  private driverIdSubject = new BehaviorSubject<number | null>(null);
  driverId$: Observable<number | null> = this.driverIdSubject.asObservable();

  private driverCompanyIdSubject = new BehaviorSubject<number | null>(null);
  driverCompanyId$: Observable<number | null> = this.driverCompanyIdSubject.asObservable();

  private addLicenseRequestedSubject = new Subject<number>();
  addLicenseRequested$: Observable<number> = this.addLicenseRequestedSubject.asObservable();

  private licenseSavedSubject = new Subject<void>();
  licenseSaved$: Observable<void> = this.licenseSavedSubject.asObservable();

  get driverId(): number | null {
    return this.driverIdSubject.getValue();
  }

  get driverCompanyId(): number | null {
    return this.driverCompanyIdSubject.getValue();
  }

  setDriverId(id: number): void {
    this.driverIdSubject.next(id);
  }

  setDriverCompanyId(id: number): void {
    this.driverCompanyIdSubject.next(id);
  }

  requestAddLicense(typeLicenseProviderId: number): void {
    this.addLicenseRequestedSubject.next(typeLicenseProviderId);
  }

  emitLicenseSaved(): void {
    this.licenseSavedSubject.next();
  }

  constructor(private http: Http) {
    super();
  }

  public getAll(
    showDisabled: boolean = false,
  ): Observable<IQualificationResponse[]> {
    return this.http
      .get(
        `${constant.URL_QUALIFICATION}?showDisabled=${showDisabled}`,
        this.getHeader(),
      )
      .map((response: Response) => response.json() as IQualificationResponse[])
      .catch((error) => Observable.throw(error.json()));
  }

  public add(request: IQualificationRequest): Observable<IResponseSuccess> {
    return this.http
      .post(constant.URL_QUALIFICATION, request, this.headerPost())
      .map((response: Response) => response.json() as IResponseSuccess)
      .catch((error) => Observable.throw(error.json()));
  }

  public update(request: IQualificationRequest): Observable<IResponseSuccess> {
    return this.http
      .put(constant.URL_QUALIFICATION, request, this.headerPost())
      .map((response: Response) => response.json() as IResponseSuccess)
      .catch((error) => Observable.throw(error.json()));
  }

  public disable(ids: number[]): Observable<IResponseSuccess> {
    return this.http
      .put(constant.URL_QUALIFICATION_DISABLE, ids, this.headerPost())
      .map((response: Response) => response.json() as IResponseSuccess)
      .catch((error) => Observable.throw(error.json()));
  }

  public getByDriver(
    driverId: number,
  ): Observable<IDriverQualificationsResponse> {
    return this.http
      .get(`${constant.URL_QUALIFICATION}/${driverId}`, this.getHeader())
      .map(
        (response: Response) =>
          response.json().data as IDriverQualificationsResponse,
      )
      .catch((error) => Observable.throw(error.json()));
  }

  public assignToDriver(
    request: IQualificationDriverRequest,
  ): Observable<IResponseSuccess> {
    return this.http
      .post(
        constant.URL_QUALIFICATION_ASSIGN_TO_DRIVER,
        request,
        this.headerPost(),
      )
      .map((response: Response) => response.json() as IResponseSuccess)
      .catch((error) => Observable.throw(error.json()));
  }

  public updateDriverPay(
    request: IQualificationDriverPayRequest,
  ): Observable<IResponseSuccess> {
    return this.http
      .put(
        constant.URL_QUALIFICATION_DRIVER_PAY,
        request,
        this.headerPost(),
      )
      .map((response: Response) => response.json() as IResponseSuccess)
      .catch((error) => Observable.throw(error.json()));
  }

  public listByProvider(
    providerId: number,
  ): Observable<IProviderQualification[]> {
    return this.http
      .get(
        `${constant.URL_QUALIFICATION_BY_PROVIDER}/${providerId}`,
        this.getHeader(),
      )
      .map((response: Response) => response.json() as IProviderQualification[])
      .catch((error) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/qualification-api.service.ts